"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var createFileScanIngressMiddleware = function () {
    var fileScanIngressMiddleware = function () { return function (next) { return function (activity) { return __awaiter(void 0, void 0, void 0, function () {
        var attachments, channelData, amsreferences, scanFile_1, fileIds;
        var _a, _b;
        return __generator(this, function (_c) {
            attachments = activity.attachments, channelData = activity.channelData;
            if (!attachments) {
                return [2 /*return*/, next(activity)];
            }
            // Patch references
            if (!((_a = channelData === null || channelData === void 0 ? void 0 : channelData.metadata) === null || _a === void 0 ? void 0 : _a.amsreferences) && ((_b = channelData === null || channelData === void 0 ? void 0 : channelData.metadata) === null || _b === void 0 ? void 0 : _b.amsReferences)) {
                activity.channelData.metadata.amsreferences = channelData.metadata.amsReferences;
            }
            amsreferences = channelData.metadata.amsreferences;
            if (amsreferences) {
                try {
                    scanFile_1 = function (fileId) {
                        var fileScanner = window.chatAdapter.fileManager.fileScanner; // eslint-disable-line @typescript-eslint/no-explicit-any
                        if (!fileScanner) {
                            return next(activity);
                        }
                        var scanResult = fileScanner.retrieveFileScanResult(fileId);
                        if (scanResult) {
                            var scan = scanResult.scan, fileMetadata_1 = scanResult.fileMetadata;
                            var index = activity.attachments.findIndex(function (attachment) { return (attachment.name === fileMetadata_1.name); }); // eslint-disable-line @typescript-eslint/no-explicit-any
                            if (!activity.channelData.fileScan) {
                                activity.channelData.fileScan = [];
                            }
                            activity.channelData.fileScan[index] = scan;
                        }
                        fileScanner.addNext(fileId, next);
                        fileScanner.addActivity(fileId, __assign({}, activity));
                    };
                    fileIds = JSON.parse(amsreferences);
                    fileIds.forEach(function (fileId) { return scanFile_1(fileId); });
                }
                catch (e) {
                    console.error(e);
                }
            }
            return [2 /*return*/, next(activity)];
        });
    }); }; }; };
    return fileScanIngressMiddleware;
};
exports.default = createFileScanIngressMiddleware;
//# sourceMappingURL=createFileScanIngressMiddleware.js.map